import { useEffect, useRef, useState } from "react";

/**
 * Хук для анимации при появлении в зоне видимости (Intersection Observer).
 * @param options rootMargin, threshold
 * @returns [ref, isInView]
 */
export function useInView(
  options: IntersectionObserverInit = {
    rootMargin: "0px 0px -80px 0px",
    threshold: 0.1,
  }
): [React.RefObject<HTMLDivElement | null>, boolean] {
  const ref = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
      }
    }, options);

    observer.observe(el);
    return () => observer.disconnect();
  }, [options.rootMargin, options.threshold]);

  return [ref, isInView];
}
